/*
 * Copyright 2026 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/kmp-project-template/blob/main/LICENSE
 */
package kpt.core.database.di

import org.koin.core.module.Module
import org.koin.dsl.module

/**
 * GENERATED from `@DbConverters` — the one-shot install for every converter whose
 * companion declares `install(<dep>)`. DO NOT HAND-EDIT.
 *
 * Room builds converters with a no-arg constructor, so a converter needing a collaborator
 * takes it post-construction and MUST get it before the first database access. Deriving
 * this from the annotation is what stops a converter being registered on the database
 * while its dependency was never installed — an encrypted column would then round-trip
 * as plaintext, silently and only in production.
 *
 * Pulled in by `DatabaseModule` via `includes(GeneratedConverterBindings)`.
 */
private object ChargeTypeConvertersInstalled

val GeneratedConverterBindings: Module = module {
    single(createdAtStart = true) {
        kpt.core.database.currency.converter.ChargeTypeConverters.install(get<kpt.core.base.crypto.FieldEncryptor>())
        ChargeTypeConvertersInstalled
    }
}
